import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class SolarApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnathorized) {
		super(token, clientId, onUnathorized);
		this.baseUrl = this.getBaseUrl() + "solar/";
	}

}
